import {BaseMuWidget} from "./BaseMuWidget";
import {MuUIDs} from "mu-widget/lib/MuUIDs";
import Sortable from "sortablejs";
import {TicketsCL} from "./generated/TicketsCL";
import {MuRouter} from "mu-widget/lib/MuRouter";
import {flashError} from "./Utils";

export class UiSplitByAttach extends BaseMuWidget
{
	public ticketId: number = 106753;
	protected cl: TicketsCL = new TicketsCL();
	public uid: string = MuUIDs.next('id');
	beforeIndex() {
		this.container.classList.add('row', 'split-by-attach');
		this.muAppendContent(`
			<div class="row">
				<div class="col-md-12">
					<strong>Rozdělení požadavku</strong> <em mu-id="message"></em>
				</div>
				<div class="col-md-6" mu-id="pCurrent">
					<div mu-id="lsCurrent" mu-widget="UiSplitByAttachList" mu-params='{"name":"Aktuální požadavek","currentTicket":true}'></div>
				</div>
				<div class="col-md-6" mu-id="pNew">
					<div mu-id="newTickets" mu-bind="newItems::@foreach">
						<div mu-widget="UiSplitByAttachList" mu-template="item"></div>			
					</div>
					<div class="buttons">
						<span class="icon-before-add btn-icon btn-icon-size-4" mu-id="bAdd">Vytvořit nové</span>
					</div>
					<ul mu-id="response" class="split-by-attach__new-tickets">
						<li mu-widget="." mu-template="newTicket">
							<a mu-bind="evidenceUid" mu-id="link"></a>
						</li>
					</ul>
				</div>
			</div>
		`);
	}

	afterIndex() {
		this.updateWidget();
		(this.muNamedWidget.lsCurrent as unknown as UiSplitByAttachList).initSortable(this);

		this.loadAttaches();
	}

	public updateWidget() {
		let lastIsEmpty: boolean = false;
		let i = 1;
		let lastWidget: UiSplitByAttachList|null = null;
		for(const wLs of this.muGetChildWidgets<UiSplitByAttachList>('newTickets')) {
			const isLast = !wLs.container.nextSibling;
			if (isLast) {
				lastIsEmpty = wLs.isEmpty();
				lastWidget = wLs;
			} else {
				if (wLs.isEmpty()) wLs.muRemoveSelf();
			}
			wLs.setName("Nový požadavek " + (i++).toString());
		}
		if (!lastIsEmpty) {
			(this.muWidgetFromTemplate('item', 'newTickets') as unknown as UiSplitByAttachList)
				.setName("Nový požadavek")
				.initSortable(this);
		} else {
			lastWidget?.setName('Nový požadavek');
		}
	}

	muFetchData(): any {
		const src = super.muFetchData();
		const res = src.newItems.map(
			(td: any) => ({
				...td,
				items: td.items.map((ad: any) => parseInt(ad.id)),
			})
		).filter((ids:{items:number[]}) => ids.items.length > 0);

		return res
	}

	async bAdd_click() {
		this.showSplitResult(
			await this.cl.withMessage('Vytvářím nové požadavky')
				.splitTicketByAttach(this.ticketId, this.muFetchData())
		);
		// todo:: zobrazení výsledků
	}

	private async loadAttaches() {
		const attaches = await this.cl.withMessage('Načítám přílohy').getAttachesFotTicketAndRelated(this.ticketId);
		this.muVisible(!!attaches.length, ["pCurrent", "pNew"]);
		this.ui.message.innerText = !attaches.length ? "Neexistují přílohy, není možné rozdělit" : "";
		this.muNamedWidget.lsCurrent.muClear('attaches');

		for (const att of attaches) {

			this.muNamedWidget.lsCurrent.muWidgetFromTemplate(
				'item',
				'attaches',
			).muBindData(att);
		}
	}

	public showSplitResult(tickets: { id: number; evidenceUid: string; url: string }[])
	{
		const router = this.getPropertyInAncestors("router") as MuRouter;
		for (const ticket of tickets) {
			const w = this.muWidgetFromTemplate(
				"newTicket",
				"newTickets",
				{
				}
			);
			w.muBindData(ticket);
			router.prepareAnchor(w.ui.link as unknown as HTMLAnchorElement, "ticket", { ticketId: ticket.id.toString() });
		}
		if (tickets.length === 0) flashError('Nebyly vybrány přílohy pro přesun do nového požadavku');
		this.ui.newTickets.innerHTML = "";
		this.updateWidget();
		this.loadAttaches();
		this.callMethodInFirstAncestors('loadList', false);
	}
}

export class UiSplitByAttachList extends BaseMuWidget {
	name: string = "";
	currentTicket: boolean = false;

    setName(name: string): UiSplitByAttachList {
        this.ui.lName.innerText = name;
		return this;
    }

	beforeIndex() {
		this.container.classList.add('split-by-attach__attach-list');
		if (this.currentTicket) this.container.classList.add('split-by-attach__attach-list--current');
		this.muAppendContent(`
			<h4 mu-id="lName"></h4>
			<ul mu-id="attaches" class="split-by-attach__attach-list-attaches" mu-bind="items::@foreach"><li 
					class="icon-before-document-file" mu-template="item" mu-widget="." 
					mu-bind='id::@attr.data-id;inTextImage|tern("split-by-attach__attach-list__item--in-text","")|prepend("icon-before-document-file "):className'>
					<span mu-bind="fileName"></span>
				</li></ul>
			` + (this.currentTicket ? `<div class="checkbox">
					<label>
						<input type="checkbox" mu-id="cShowAll">
						Zobrazit vše
					</label>
				</div>` : '') + `
		`)
	}

	cShowAll_change() {
		this.container.classList.toggle('split-by-attach__attach-list--hide-inline', !this.ui.cShowAll.checked);
	}

	afterIndex() {
		this.setName(this.name);
		if (this.currentTicket) this.cShowAll_change();
	}

	public isEmpty(): boolean
	{
		return this.ui.attaches.childElementCount === 0;
	}

	initSortable(parentWidget: UiSplitByAttach) {
		new Sortable(
			this.ui.attaches,
			{
				group: parentWidget.uid,
				onChange: () => parentWidget.updateWidget()
			}
		);
	}
}